import React from "react";
import { Carousel } from "primereact/carousel";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

function Trigr() {

  const slides = [
    { src: "/assets/img/triger_sec1.png", alt: "triger screen 1" },
    { src: "/assets/img/triger_sec2.png", alt: "triger screen 2" },
    { src: "/assets/img/triger_sec3.png", alt: "triger screen 3" },
    { src: "/assets/img/triger_sec4.png", alt: "triger screen 4" },
    { src: "/assets/img/triger_sec5.png", alt: "triger screen 5" },
  ];

  const slideTemplate = (slide) => (
    <div className="flex justify-center">
      <img
        src={slide.src}
        alt={slide.alt}
        className="w-full rounded-md"
        
      />
    </div>
  );
  return (
    <>
      <section className="position-relative  mt-5 mb-5 triger_sec">
        <div className="container position-relative zi1">
          <div className="row  text-center">
            <div className="col-md-6 m-auto">
              <img src="/assets/img/logomark.png" alt="a_plan" className="logomark " />
              <p className=" mb-md-4 mb-3 ">
                The most advanced AI-driven platform designed to optimize your
                body, mind, and longevity. TRIGR helps you perform at your best
                by combining real-time biometric tracking, precision AI
                coaching, and cutting-edge performance insights
              </p>
              <div
                id="demo"
                className="carousel slide "
                data-bs-ride="carousel"
              >
                <div className="mobile_sce position-relative">
                  {/* Mobile frame (background) */}
                  <img
                    src="/assets/img/triger_mobile.png"
                    alt="mobile frame"
                    className="w-full max-w-xs"
                  />

                  {/* Carousel inside the screen area */}
                  <div className="carousel-inner  carousel_inner_bocile  ">
                    <Carousel
                      value={slides}
                      itemTemplate={slideTemplate}
                      numVisible={1}
                      numScroll={1}
                      circular
                      autoplayInterval={2000}
                      showIndicators={false}
                      showNavigators={false}
                    />
                  </div>
                </div>
              </div>
              {/* <div
                id="demo"
                className="carousel slide "
                data-bs-ride="carousel"
              >
                {/* The slideshow/carousel */}
               {/*} <div className="mobile_sce position-relative">
                  <img
                    src="/assets/img/triger_mobile.png"
                    alt="triger"
                    className="w100"
                  />
                  <div className="carousel-inner  carousel_inner_bocile  ">
                    <div className="carousel-item active">
                      <img
                        src="/assets/img/triger_sec1.png"
                        alt="triger screen"
                        className="w100"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src="/assets/img/triger_sec2.png"
                        alt="triger screen"
                        className="w100"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src="/assets/img/triger_sec3.png"
                        alt="triger screen"
                        className="w100"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src="/assets/img/triger_sec4.png"
                        alt="triger screen"
                        className="w100"
                      />
                    </div>
                    <div className="carousel-item">
                      <img
                        src="/assets/img/triger_sec5.png"
                        alt="triger screen"
                        className="w100"
                      />
                    </div>
                  </div>
                </div>
                <div className="carousel-indicators">
                  <button
                    type="button"
                    data-bs-target="#demo"
                    data-bs-slide-to={0}
                    className="active"
                  />
                  <button
                    type="button"
                    data-bs-target="#demo"
                    data-bs-slide-to={1}
                  />
                  <button
                    type="button"
                    data-bs-target="#demo"
                    data-bs-slide-to={2}
                  />
                  <button
                    type="button"
                    data-bs-target="#demo"
                    data-bs-slide-to={3}
                  />
                  <button
                    type="button"
                    data-bs-target="#demo"
                    data-bs-slide-to={4}
                  />
                </div>
                {/* Left and right controls/icons */}
              {/*<button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#demo"
                  data-bs-slide="prev"
                >
                  <span className="carousel-control-prev-icon" />
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#demo"
                  data-bs-slide="next"
                >
                  <span className="carousel-control-next-icon" />
                </button>
              </div> */}
              <h2 className="hadding2 mt-4 mt-md-5">Real-time tracking</h2>
              <p className="op0_5">
                Track your team's progress in real-time with Trigr. Stay updated
                on project milestones and make informed decisions instantly.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Trigr;
